import React, { useState } from "react";
import { Lock } from "lucide-react";
import { authService } from "../services/auth.service";
import { useAuth } from "../hooks/useAuth";
import { useToast } from "../context/ToastContext";
import "../styles/clients.css";

export default function SettingsPage() {
    const { user } = useAuth();
    const { showToast } = useToast();

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!currentPassword) { setError("Current password is required."); return; }
        if (!newPassword) { setError("New password is required."); return; }
        if (newPassword.length < 6) { setError("New password must be at least 6 characters."); return; }
        if (newPassword !== confirmPassword) { setError("Passwords do not match."); return; }

        setLoading(true);
        try {
            await authService.setPassword(currentPassword, newPassword);
            setSuccess("Password updated successfully.");
            showToast("Password updated successfully.");
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
        } catch (err: any) {
            setError(err.response?.data?.message || err.response?.data?.msg || "Failed to update password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="clients-container" style={{ maxWidth: 520 }}>
            <div className="clients-header">
                <h1>Settings</h1>
            </div>

            <div className="settings-card">
                <div className="settings-section-header">
                    <Lock size={18} />
                    <h2>Change Password</h2>
                </div>
                <p className="settings-section-desc">
                    Update the password for <strong>{user?.email}</strong>
                </p>

                <form className="modal-form" onSubmit={handleSubmit}>
                    {error && <div className="modal-error">{error}</div>}
                    {success && <div className="settings-success">{success}</div>}

                    <div className="modal-field">
                        <label htmlFor="current-password">Current Password</label>
                        <input
                            id="current-password"
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            placeholder="Enter current password"
                            autoComplete="current-password"
                        />
                    </div>

                    <div className="modal-field">
                        <label htmlFor="new-password">New Password</label>
                        <input
                            id="new-password"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Enter new password"
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="modal-field">
                        <label htmlFor="confirm-password">Confirm New Password</label>
                        <input
                            id="confirm-password"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm new password"
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="modal-actions">
                        <button type="submit" className="btn-modal-submit" disabled={loading}>
                            {loading ? "Updating..." : "Update Password"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
